import React from 'react';
import styled from 'styled-components';
import TFDropdown from '../TFDropdown/TFDropdown';
import DeleteIcon from '../../assets/delete.svg';
import { Divider } from '../CommonStyledComponents/CommonStyledComponents';
import { FormErrorsAdditionalCrew } from './TripDrawer';

interface Option {
  value: string;
  title: string;
}

interface EditAdditionalCrewSectionProps {
  roles: Option[];
  users: Option[];
  foundRole: Option | null;
  foundPerson: Option | null;
  handleSelectedRole: (id: string, index: number) => void;
  handleSelectedPerson: (id: string, index: number) => void;
  index: number;
  removeCrew: (index: number) => void;
  additionalCrewLength: number;
  formError: FormErrorsAdditionalCrew;
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-end;
  align-self: end;
`;

const DeleteButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  margin-top: 28px;
`;

const EditAdditionalCrewSection: React.FC<EditAdditionalCrewSectionProps> =
  ({
    roles,
    users,
    foundRole,
    foundPerson,
    handleSelectedRole,
    handleSelectedPerson,
    index,
    removeCrew,
    additionalCrewLength,
    formError,
  }) => {

  return (
    <>
      <Wrapper data-testid="EditAdditionalCrewSection--Wrapper">
        <TFDropdown
          options={roles}
          onSelect={(option) => handleSelectedRole(option.value, index)}
          label="Role"
          initialValue={foundRole}
          id="EditAdditionalCrewRole"
        />
        <TFDropdown
          options={users}
          onSelect={(option) => handleSelectedPerson(option.value, index)}
          label="Person"
          initialValue={foundPerson}
          id="EditAdditionalCrewPerson"
          disabled={!foundRole}
          status={formError?.person?.status}
          statusMessage={formError?.person?.message}
        />
        <ButtonWrapper>
          <DeleteButton
            type="button"
            onClick={(): void => {
              removeCrew(index);
            }}
            data-testid="EditAdditionalCrewSection--DeleteButton"
          >
            <img src={DeleteIcon} alt="delete button" />
          </DeleteButton>
        </ButtonWrapper>
      </Wrapper>
    {index + 1 < additionalCrewLength ? <Divider /> : null}
    </>
  );
};

export default EditAdditionalCrewSection;
